import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../../../shared";
import { JobInsertRequest } from "./job-insert-request";
import { JobUpdateRequest } from "./job-update-request";
import { JobScheduleInsertRequest } from "./job-schedule-insert-request";
import { JobScheduleUpdateRequest } from "./job-schedule-update-request";
import { RecipientRequest } from "./Recipient-request";
import { StringRequest } from "./string-request";

@Injectable()
export class DataService_ScheduledJobs {
	constructor(private httpclientService: HttpclientService) {}

	JobMainTableSelectList() {
		var postResult$ = new Subject();
		var url = "ReportInbox/JobMainTableSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ReportScriptsSelectList() {
		var postResult$ = new Subject();
		var url = "ReportInbox/ReportScriptsSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserSelectList() {
		var postResult$ = new Subject();
		var url = "ReportInbox/UserSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	JobAddUsersSelectList() {
		var postResult$ = new Subject();
		var url = "ReportInbox/JobAddUsersSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	JobInsert(parms: JobInsertRequest) {
		var postResult$ = new Subject();
		var url = "ReportInbox/JobInsert?";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	JobUpdate(parms: JobUpdateRequest) {
		var postResult$ = new Subject();
		var url = "ReportInbox/JobUpdate?";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	JobToggle(JobID: number, Active: boolean) {
		var postResult$ = new Subject();
		var url = "ReportInbox/JobToggle?JobID=" + JobID + "&Active=" + Active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	JobDelete(JobID: number, DeleteResults: boolean) {
		var postResult$ = new Subject();
		var url = "ReportInbox/JobDelete?JobID=" + JobID + "&DeleteResults=" + DeleteResults;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	JobScheduleSelectList(JobID: number) {
		var postResult$ = new Subject();
		var url = "ReportInbox/JobScheduleSelectList?JobID=" + JobID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	JobScheduleInsert(parms: JobScheduleInsertRequest) {
		var postResult$ = new Subject();
		var url = "ReportInbox/JobScheduleInsert?";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	JobScheduleUpdate(parms: JobScheduleUpdateRequest) {
		var postResult$ = new Subject();
		var url = "ReportInbox/JobScheduleUpdate?";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	JobScheduleToggle(JobScheduleID: number, Active: boolean) {
		var postResult$ = new Subject();
		var url = "ReportInbox/JobScheduleToggle?JobScheduleID=" + JobScheduleID + "&Active=" + Active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	JobScheduleDelete(JobScheduleID: number) {
		var postResult$ = new Subject();
		var url = "ReportInbox/JobScheduleDelete?JobScheduleID=" + JobScheduleID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RecipientSelectList(JobID: number) {
		var postResult$ = new Subject();
		var url = "ReportInbox/RecipientSelectList?JobID=" + JobID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	JobRecipientInsert(parms: RecipientRequest) {
		var postResult$ = new Subject();
		var url = "ReportInbox/JobRecipientInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	JobRecipientDelete(parms: RecipientRequest) {
		var postResult$ = new Subject();
		var url = "ReportInbox/JobRecipientDelete";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ProcessJob(JobID: number) {
		var postResult$ = new Subject();
		var url = "ReportInbox/ProcessJob?JobID=" + JobID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ReportScriptOptionSelectList(parms: StringRequest) {
		var postResult$ = new Subject();
		var url = "ReportInbox/ReportScriptOptionSelectList";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
